
import WithColorMixin from '@/mixins/WithColorMixin.vue';
import { defineComponent } from 'vue';
import WithBandSizeMixin from '@/mixins/WithBandSizeMixin.vue';

/**
 * Header band component. If the band has a letter, also render the slider.
 * 
 * The slider randomly moves up and down between limits.
 */
const __default__ = defineComponent({
    name: 'HeaderBand',
    props: {
        letter: String,
        position: Number,
        minimized: Boolean
    },
    mixins: [WithColorMixin, WithBandSizeMixin],
    data () {
        return {
            sliderPosition: 180,
        }
    },
    computed: {
        /**
         * The slider is only visible for lettered bands.
         */
        displaySlider(): boolean {
            return Boolean(this.letter)
        },
        flex(): string {
            return (this.minimized && this.letter ? `0 ${this.headerBandMinWidth}px` : `0 ${this.headerBandMaxWidth}px`)
        },
        height(): string {
            return (this.minimized ? this.headerBandMinHeight : this.headerBandMaxHeight) + "px"
        },
        highlightedHeight(): string {
            return (this.minimized ? this.headerBandMinHeight : this.sliderPosition) + "px"
        },
        sliderHeightAttribute(): string {
            return (this.minimized ? this.sliderHeightMinimized : this.sliderHeight) + "px"
        },
        fontSizeAttribute(): string {
            return (this.minimized ? this.fontSizeMinimized : this.fontSize) + "pc"
        },
        letterTopMarginAttribute(): string {
            return (this.minimized ? this.letterTopMarginMinimized : this.letterTopMargin) + "px"
        }
    },
    methods: {
        /**
         * Move the slider, pick a direction and try to move towards it. Clamp the result between minium and maximum height.
         */
        moveSlider() {
            this.sliderPosition += (Math.floor(Math.random() * 3) - 1) * this.sliderMovement;
            this.sliderPosition = Math.min(Math.max(this.sliderPosition, this.headerSliderMinHeight), this.headerSliderMaxHeight);
        },
        /**
         * Decide when the next slider movement will happen.
         * 
         * @param min minimum time in milliseconds
         */
        getNextSliderMoveTime(min = 5000) {
            return Math.floor(Math.random() * 3000) + min;
        },
        /**
         * Start the movement timeout, on timeout: move the slider and set the next movement.
         */
        startMoveTimeout(milliseconds: number) {
            setTimeout(() => {
                this.moveSlider();

                this.startMoveTimeout(this.getNextSliderMoveTime());
            }, milliseconds)
        }
    },
    mounted: function () {
        if (this.displaySlider) {
            this.sliderPosition = Math.floor(Math.random() * (this.headerSliderMaxHeight - this.headerSliderMinHeight + 1)) + this.headerSliderMinHeight
            this.startMoveTimeout(this.getNextSliderMoveTime(1000));
        }
    },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "eb979b72": (_ctx.flex),
  "027cf08a": (_ctx.lightColor),
  "5e0d3016": (_ctx.height),
  "750b6bcc": (_ctx.highlightedHeight),
  "7ff397ff": (_ctx.darkColor),
  "60c4c986": (_ctx.sliderHeightAttribute),
  "3598a6e6": (_ctx.letterTopMarginAttribute),
  "30adb3fe": (_ctx.fontSizeAttribute)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__